import type { IObjectiveConflictsBetweenLoanFeatures } from './ObjectiveConflictsBetweenLoanFeatures.interface';
import { YesNoOption } from '../global/YesNoOption.enum';

export default class ObjectiveConflictsBetweenLoanFeatures
  implements IObjectiveConflictsBetweenLoanFeatures {
  anyConflictsMarkedAsImportant: YesNoOption;
  conflictsComments: string;

  static build = (data: IObjectiveConflictsBetweenLoanFeatures) =>
    new ObjectiveConflictsBetweenLoanFeatures(data);

  static blank = () => new ObjectiveConflictsBetweenLoanFeatures();

  /**
   * Constructor
   * @param {IObjectiveConflictsBetweenLoanFeatures} data
   */
  constructor(data?: IObjectiveConflictsBetweenLoanFeatures) {
    // TODO: data?.anyConfilctsMarkedAsImportant is legacy data structure
    this.anyConflictsMarkedAsImportant = YesNoOption.of(
      data?.anyConfilctsMarkedAsImportant?.name ||
        data?.anyConflictsMarkedAsImportant?.name ||
        data?.anyConfilctsMarkedAsImportant?.toString() ||
        data?.anyConflictsMarkedAsImportant?.toString()
    );
    this.conflictsComments = data?.conflictsComments || '';
  }
}
